<template>
  <div>
    <wc-data-box
      title='Driveway Ratings'
      :loading='isLoading'
      showAdd
      @add='addDR'
    >
      <v-data-table
        dense
        :items='filteredDRs'
        :headers='headers'
        :items-per-page='-1'
        hide-default-footer
        @click:row='editDR'
      >
        <template v-slot:item.description='{ item }'>
          {{ item.description }} <wc-archived v-if='item.archived'></wc-archived>
        </template>
        <template v-slot:item.base_price='{ item }'>
          {{ item.base_price | decMoney }}
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-dialog
      title='Driveway Rating Details'
      :showDialog='showDialog'
      width='450'
      @cancel='showDialog = false'
      @save='updateDR'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='Description'
              v-model='drCopy.description'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Rating'
              v-model='drCopy.rating'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Time on site'
              v-model='drCopy.time_on_site'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Base price'
              v-model='drCopy.base_price'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

    </wc-dialog>
  </div>
</template>

<script>
import settingsAPI from '../../api/settings'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'driveway-ratings',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: true,
    showDialog: false,
    isFormValid: false,
    drs: [],
    drCopy: {},
    headers: [
      { text: 'Description', value: 'description', align: 'left' },
      { text: 'Rating', value: 'rating', align: 'center' },
      { text: 'Time on Site', value: 'time_on_site', align: 'center' },
      { text: 'Base Rate', value: 'base_price', align: 'end' }
    ]
  }),
  computed: {
    filteredDRs () {
      return _.orderBy(this.drs, 'rating')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.drs = await settingsAPI.getDrivewayRatings()
      this.isLoading = false
    },
    editDR (item) {
      this.drCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    addDR () {
      this.drCopy = {}
      this.showDialog = true
      setTimeout(() => {
        this.$refs.form.reset()
      }, 50)
    },
    async updateDR () {
      this.isSaving = true
      if (this.drCopy.id) {
        this.drs = miscServices.replaceObject(this.drs, await settingsAPI.updateDrivewayRating(this.drCopy))
      } else {
        this.drs.push(await settingsAPI.createDrivewayRating(this.drCopy))
      }
      this.showDialog = false
      this.isSaving = false
    }
  }
}
</script>
